import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {DatalakeEvent} from '../../models/abstract/datalake-event';
import {NewrelicService} from '../newrelic/newrelic.service';
import {TrackResponse} from '../../models/track-response';
import {StaticValuesUtils} from "../../utils/static-values/static-values.utils";

// Return the native window obj
function _window(): any {
    return window;
}

@Injectable()
export class UpaService {
    static URL = '/s-transfers/api/tracking/upa/track';
    static DATALAKE_CORRECTNESS_OK = 'ok';
    static DEBUG_MODE = false;

    constructor(private _httpClient: HttpClient) {}

    private static get nativeWindow(): any {
        return _window();
    }

    track(event: DatalakeEvent): void {
        const url = `${UpaService.URL}/${event.datalakeTopicName}?pageviewId=${StaticValuesUtils.getPageViewId()}`;
        try {
            this._httpClient.post(url,
                {
                    ...event.datalakeTopicBody,
                    data: this.objToString(event.datalakeTopicBody.data)
                }
            ).subscribe(response => this.handleDatalakeTrackSuccess.call(this, event, response));
        } catch (error) {
            this.handleDatalakeTrackError(event, error);
        }
    }

    private handleDatalakeTrackError(event: DatalakeEvent, error: any): void {
        const errorString = this.buildDatalakeErrorString(event, error);
        NewrelicService.noticeError(errorString);
        this.debug(errorString);
    }

    private handleDatalakeTrackSuccess(event: DatalakeEvent, response: TrackResponse): void {
        try {
            if (response.correctness === UpaService.DATALAKE_CORRECTNESS_OK) {
                this.debug(`Tracking sucessfully for ${event.datalakeTopicName} event.`);
            } else {
                const errorString = this.convertDatalakeResponseToString(event, response);
                NewrelicService.noticeError(errorString);
                this.debug(errorString);
            }
        } catch(error) {
            const errorString = this.buildDatalakeErrorString(event, error);
            NewrelicService.noticeError(errorString);
            this.debug(errorString);
        }
    }

    private convertDatalakeResponseToString(event: DatalakeEvent, response: TrackResponse): string {
        // Esto se podría mejorar con más detalle (unknown fields, missing fields, etc.)
        return `Tracking error while tracking ${event.datalakeTopicName} event. Body: ${JSON.stringify(event.datalakeTopicBody)}. Response: ${JSON.stringify(response)}`;
    }

    public objToString(obj) {
        for (const p in obj) {
            if (obj.hasOwnProperty(p) && typeof obj[p] !== 'string') {
                obj[p] = JSON.stringify(obj[p]);
            }
        }
        return obj;
    }

    private buildDatalakeErrorString(event: DatalakeEvent, error: any): string {
        return `Unexpected error tracking ${event.datalakeTopicName} event. Body: ${JSON.stringify(event.datalakeTopicBody)}. Error: ${JSON.stringify(error)}`;
    }

    private debug(message: string, extraInfo?: any): void {
        if (UpaService.DEBUG_MODE) {
            const extras = extraInfo ? `. ${JSON.stringify(extraInfo)}` : ``;
            console.info(`DatalakeTrackingService: ${message}${extras}`);
        }
    }
}
